<template>
  <div class="main-container dark bg-with-image h-100">
    <app-header />
    <div class="container h-100">
      <div
        class="card mx-5 h-100 d-flex flex-column align-items-center justify-content-center"
      >
        <template v-if="doubleAccessError">
          <h1 class="page-title mb-2">Acesso em outro navegador detectado</h1>
          <span class="text-center mb-4">
            Identificamos que esta entrevista está sendo acessada
            simultaneamente em outro navegador ou dispositivo.<br />
            Para garantir a segurança e integridade das informações, o acesso
            foi bloqueado neste navegador.<br />
            Por favor, aguarde até 5 minutos após encerrar o acesso no outro
            navegador e tente novamente.
          </span>
        </template>
        <template v-else>
          <h1 class="page-title mb-2">Acesso não autorizado</h1>
          <span class="text-center mb-4">
            Você não possui permissão para acessar o sistema.
          </span>
        </template>
        <button class="btn btn-orange col-auto mx-1" @click.prevent="goBack">
          Retornar ao sistema
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import * as sharedTypes from "../../shared/store/types";
import AppHeader from "../components/AppHeader";
export default {
  components: {
    AppHeader,
  },
  mounted() {
    this.setNoOptionsHeaderType();
  },
  computed: {
    doubleAccessError() {
      return this.$route.params.doubleAccessError || false;
    },
  },
  methods: {
    ...mapActions({
      setNoOptionsHeaderType: sharedTypes.SET_NO_OPTIONS_HEADER_TYPE,
    }),
    goBack() {
      const customerToken = this.$route.params.customerToken || null;
      if (this.doubleAccessError && customerToken) {
        window.location.href =
          process.env.VUE_APP_ADMIN_URL + "/customer/" + customerToken;
      } else {
        window.location.href = process.env.VUE_APP_ADMIN_URL;
      }
    },
  },
};
</script>
